import React, { useEffect, useState } from 'react';
import { calculateTimeLeft } from './utils';
import moment from 'moment-timezone';

type Props = {
  targetDate: moment.Moment;
};

const Countdown = ({ targetDate }: Props) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(targetDate));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft(targetDate));
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return <span>{timeLeft}</span>;
};

export default Countdown;
